import React from 'react';
import { useSelector } from 'react-redux';
import EmployeeTab1 from './EmployeeTab1';

export default function EmployeeCreate() {
  const userBranch = useSelector(state => state.user.user.branch);

  // 생성 모드: employ를 전달하지 않음
  return <EmployeeTab1 employ={null} userBranch={userBranch} />;
}
